import { useContext, useEffect, useState } from 'react'

import Select from 'react-select'
import Button from '../common/Button'
import { putRequest } from '../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../context/global_context'

const OPTIONS_CONFIG = {
  wire_list: 'Wire list',
  dtcs: 'Dtcs',
  dtcs_dependencies: 'Dtcs Dependencies',
  modules: 'Modules',
  inlines: 'Inlines',
  harness_description: 'Harness description',
  sig_list: 'Sig list',
  sales_codes: 'Sales codes',
  sales_code_constraints: 'Sales code constraints',
  connector_layout: 'Connector layout',
  device_connections: 'Device connections',
  power_distributions: 'Power distributions',
  component_list: 'Component list',
  functional_diagram: 'Functional Diagram',
}

const CSV_OPTIONS = [
  { value: 'wire_list', label: 'Wire list' },
  { value: 'dtcs', label: 'Dtcs' },
  { value: 'dtcs_dependencies', label: 'Dtcs Dependencies' },
  { value: 'modules', label: 'Modules' },
  { value: 'inlines', label: 'Inlines' },
  { value: 'harness_description', label: 'Harness description' },
  { value: 'sig_list', label: 'Sig list' },
  { value: 'sales_codes', label: 'Sales codes' },
  { value: 'sales_code_constraints', label: 'Sales code constraints' },
  { value: 'connector_layout', label: 'Connector layout' },
  { value: 'device_connections', label: 'Device connections' },
  { value: 'power_distributions', label: 'Power distributions' },
  { value: 'component_list', label: 'Component list' },
  { value: 'functional_diagram', label: 'Functional Diagram' },
]

const CsvDependencies = (props) => {
  const { vehicle } = useParams()
  const [selectedValue, setSelectedValue] = useState({})
  const [state, dispatch] = useContext(NavContext)

  useEffect(() => {
    if (props?.vehicleDetails?.make_model_id) {
      setOptionsValues()
    }
  }, [props.vehicleDetails])

  const setOptionsValues = () => {
    let tempOptions = {}
    Object.keys(props.vehicleDetails?.metadata).map((key) => {
      tempOptions[key] = []
      props.vehicleDetails?.metadata[key].map((row) => {
        tempOptions[key].push({
          value: row,
          label: OPTIONS_CONFIG[row],
        })
      })
    })
    setSelectedValue(tempOptions)
  }

  const saveCsvDependency = async (e) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Saving CSV Dependency',
        showLoader: true,
      },
      notification: {},
    })
    e.preventDefault()
    let res = await putRequest(
      `/api/vehicles/save_csv_dependency/${vehicle}/`,
      selectedValue
    )
    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: 'CSV Dependency saved successfully',
      },
    })
  }

  return (
    <>
      <form
        onSubmit={(e) => {
          saveCsvDependency(e)
        }}
      >
        <div className="p-2 font-bold br-bottom-top-1px">
          ** CSV dependencies **
        </div>
        <div style={{ height: '30rem', overflowY: 'auto' }}>
          {CSV_OPTIONS.map((dependency) => {
            return (
              <div
                className="w-full flex items-center justify-between p-2"
                key={dependency.value}
              >
                <div className="w-1/4">{dependency.label}</div>
                <div className="w-2/3">
                  <Select
                    name={dependency.value}
                    classNamePrefix="dtcs-filter"
                    isMulti={true}
                    value={selectedValue[dependency.value]}
                    options={CSV_OPTIONS}
                    placeholder={'Select Dependency'}
                    className="w-full"
                    onChange={(value) => {
                      setSelectedValue({
                        ...selectedValue,
                        [dependency.value]: value,
                      })
                    }}
                  />
                </div>
              </div>
            )
          })}
        </div>

        <div className="flex justify-end pr-2">
          <div className="w-1/4 p-2">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text="Save CSV dependencies"
            />
          </div>
        </div>
      </form>
    </>
  )
}

export default CsvDependencies
